import { useHistory } from 'react-router'
import React, { useCallback, useEffect } from 'react'

import { useActionApi, usePersistedState } from 'hooks'
import Api from 'api'

import moment from 'dayjs'
import ConfirmDetails from 'components/EditPost/ConfirmDetails'
import { entities } from 'reduxStore'
import { EditedJob } from 'components/EditJob'
import FixedLoader from 'components/FixedLoader'
import FixedError from 'components/FixedError'

export default function EditJobPostConfirmationPage() {
  const history = useHistory()
  const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

  const [jobPostingLoading, jobPostingError, postJobApi] = useActionApi({
    apiMethod: Api.postJob,
    onSuccess: useCallback(() => {
      history.push({
        pathname: 'postSuccess',
        state: {repost : false}});
    }, [history])
  })
  const [editJobPostingLoading, editJobPostingError, editJobApi] = useActionApi(
    {
      apiMethod: Api.editJob,
      onSuccess: useCallback(() => {
        history.push({
          pathname: 'postSuccess',
          state: { repost: !persistedJob.changed }
        })
      }, [history])
    }
  )

  const [persistedJob, saveJob] = usePersistedState({
    entityName: entities.editedJobPost,
    initialValue: {} as EditedJob
  })
  const dentistUser: any = usePersistedState({
    entityName: entities.user
  })[0]

  const navigateToEditOnRoute = useCallback(
      (route: any) => {
      history.push({
        pathname: route,
        state: {
          mode: 'edit'
        }
      })
    },
    [history]
  )

  /*Allows to change date if reposting, need to refactor */

  useEffect(() => {
    if (
      ((!persistedJob.datesAutoEdited && persistedJob.status === 2) ||
      persistedJob.status === 3) && moment(persistedJob.startDate).isBefore(moment())
    ) {
      const startDate = new Date()
      const endDate = new Date(+moment(startDate).add(30, 'days'))
      saveJob({
        ...persistedJob,
        startDate,
        endDate,
        datesAutoEdited: true
      })
    }
  }, [persistedJob.id])

  return (
    <>
      <ConfirmDetails
        mode={mode}
        editedJobPost={persistedJob}
        nextText={'Submit'}
        isNextAvailable={false}
        onPosition={useCallback(() => {
          navigateToEditOnRoute('postPosition')
        }, [navigateToEditOnRoute])}
        onLocation={useCallback(() => {
          navigateToEditOnRoute('postOfficeLocation')
        }, [navigateToEditOnRoute])}
        onAvailability={useCallback(() => {
          navigateToEditOnRoute('postAvailability')
        }, [navigateToEditOnRoute])}
        onDates={useCallback(() => {
          navigateToEditOnRoute('postDates')
        }, [navigateToEditOnRoute])}
        onRequirements={useCallback(() => {
          navigateToEditOnRoute('postCandidateRequirements')
        }, [navigateToEditOnRoute])}
        onTitleDescription={useCallback(() => {
          navigateToEditOnRoute('postTitleDescription')
        }, [navigateToEditOnRoute])}
        onChangeEmail={useCallback(
          (notificationEmail: any) => {
            saveJob({
              ...persistedJob,
              notificationEmail
            })
          },
          [saveJob, persistedJob]
        )}
        onNext={useCallback(() => {
          if (mode === 'post') {
            postJobApi(persistedJob)
          } else {
            editJobApi(persistedJob)
          }
          return ''
        }, [mode, postJobApi, editJobApi, persistedJob, dentistUser.email])}
      />
      <FixedLoader loading={jobPostingLoading || editJobPostingLoading} />
      <FixedError error={jobPostingError || editJobPostingError} />
    </>
  )
}
